// IMPORT PACKAGE REFERENCES

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Redirect } from 'react-router-dom';
import { NavLink, withRouter } from 'react-router-dom';

import { login } from '../State/Actions/UserActions';

// COMPONENT

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {password: '', username: ''};
    
        this.emailChange = this.emailChange.bind(this);
        this.passwordChange = this.passwordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    
    componentWillReceiveProps(nextProps) {
        if (nextProps.loggedIn) {
            this.props.history.push('/');
        } else if (nextProps.failed) {
            // If the login failed.
            alert(nextProps.message);
        }
    }

    componentDidMount() {
        if (this.props.loggedIn) {
            this.props.history.push('/');
        }
    }
  
    passwordChange(event) {
        this.setState({password: event.target.value});
    }

    emailChange(event) {
        this.setState({username: event.target.value});
    }
  
    handleSubmit(event) {
        event.preventDefault();

        let email = this.state.username;
        let password = this.state.password;

        this.props.login(email, password);
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSubmit(event);
        }
    }

    render() {
        return (
            <div className="container py-5">
    <div className="row">
        <div className="col-md-12">
            <div className="row">
                <div className="col-md-6 mx-auto">

                    <div className="card rounded-0">
                        <div className="card-header">
                            <h3 className="mb-0">Login</h3>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label>Username</label>
                                <input onKeyPress={this.handleKeyPress} onChange={this.emailChange} type="text" value={this.state.username} className="form-control form-control-lg rounded-0" />
                                <div className="invalid-feedback">Oops, you missed this one.</div>
                            </div>
                            <div className="form-group">
                                <label>Password</label>
                                <input onKeyPress={this.handleKeyPress} onChange={this.passwordChange} value={this.state.password} type="password" className="form-control form-control-lg rounded-0"/>
                                <div className="invalid-feedback">Enter your password too!</div>
                            </div>
                            <button onClick={this.handleSubmit} className="btn btn-success btn-lg float-right" id="btnLogin">Login</button>
                        </div>
                    </div>

                </div>


            </div>

        </div>
    </div>
</div>
        );
    }
}

LoginPage.propTypes = {
    history: PropTypes.object.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggedIn, failed, message } = state.userReducer;
    return { loggedIn, failed, message };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ login }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage));


// EXPORT COMPONENT

export { hoc as LoginPage };